import { createRoot, hydrateRoot } from "react-dom/client";
import posthog from "posthog-js";
import App from "./App";
import "./index.css";

posthog.init("phc_upueCAjf5PDJ8rm7XJEvQ3X6JCccJmc3HJ55swkntohm", {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only",
  session_recording: { maskAllInputs: false },
});

(window as any).posthog = posthog;

const rootEl = document.getElementById("root")!;

if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, <App />);
} else {
  createRoot(rootEl).render(<App />);
}
